import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../lib/api.ts';

interface Props {
  repoId: string;
  sourceSha: string;
  onClose: () => void;
  onCreated: (branchName: string) => void;
}

export function CreateBranchModal({ repoId, sourceSha, onClose, onCreated }: Props) {
  const qc = useQueryClient();
  const [name, setName] = useState('');

  const mutation = useMutation({
    mutationFn: () => api.createBranch(repoId, name, sourceSha),
    onSuccess: async (branch) => {
      await qc.invalidateQueries({ queryKey: ['graph', repoId] });
      onCreated(branch.name);
      onClose();
    },
  });

  return (
    <div
      className="modal-backdrop"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      onKeyDown={(e) => { if (e.key === 'Escape') onClose(); }}
    >
      <div className="modal">
        <h2>Nouvelle branche</h2>
        <p>
          Depuis : <code>{sourceSha.slice(0, 8)}</code>
        </p>
        <label className="col" style={{ gap: 4 }}>
          <span>Nom de la branche</span>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="feat/ma-nouvelle-branche"
            autoFocus
          />
        </label>
        <div className="row" style={{ marginTop: 12, justifyContent: 'flex-end' }}>
          <button className="secondary" onClick={onClose}>
            Annuler
          </button>
          <button
            disabled={name.trim().length === 0 || mutation.isPending}
            onClick={() => mutation.mutate()}
          >
            Créer la branche
          </button>
        </div>
        {mutation.isError && (
          <p className="badge error">Erreur : {(mutation.error as Error).message}</p>
        )}
      </div>
    </div>
  );
}
